import Icon from '../components/Icon';

const Weather40 = Icon(
  'weather-40',
  <>
    <path
      fillRule="evenodd"
      d="M4.067 7.27c.583-3.417 3.549-6.02 7.125-6.02a7.22 7.22 0 0 1 6.063 3.302C20.3 4.6 22.75 7.09 22.75 10.15c0 3.09-2.498 5.599-5.584 5.599h-.959a1 1 0 0 1-.058.127l-1.5 2.583a.75.75 0 0 1-1.298-.753l1.137-1.957h-5.78a1 1 0 0 1-.06.127l-1.5 2.583a.75.75 0 1 1-1.297-.753l1.137-1.957H5.62a4.377 4.377 0 0 1-4.371-4.383 4.38 4.38 0 0 1 2.817-4.098m7.125-4.52c-2.966 0-5.408 2.263-5.7 5.165a.75.75 0 0 1-.565.653 2.88 2.88 0 0 0-2.177 2.799 2.877 2.877 0 0 0 2.871 2.883h11.545a4.09 4.09 0 0 0 4.084-4.1 4.09 4.09 0 0 0-4.36-4.09.75.75 0 0 1-.705-.38 5.72 5.72 0 0 0-4.993-2.93m-.169 14.59a.75.75 0 0 1 .303 1.017L9.66 21.44a.75.75 0 1 1-1.32-.713l1.667-3.084a.75.75 0 0 1 1.016-.303"
      clipRule="evenodd"
    />
  </>
);

export default Weather40;
